import React from 'react'
import { Field } from 'redux-form'
import { pt, buildPropTypes } from 'common-data/proptypehelpers'
import { FieldLayoutBox } from './FieldLayoutBox'
import { FieldValueFormatter, FieldValueParser } from './FieldValueConverters'
import { Input } from 'reactstrap'
import _ from 'common-tools/LodashHelper'

class ViewBoxClass extends React.Component {
  static propTypes = buildPropTypes([

  ], {
    type: pt.string
  })

  render () {
    const { type, formatter, ...rest } = this.props

    return (
      <FieldLayoutBox {...rest}>
        {({ showError, value, onChange, name, placeHolder, loading }) => <Input type='text' readOnly name={`view${name}`} id={`view${name}`} value={_.isFunction(formatter) ? formatter(value) : value} />}
      </FieldLayoutBox>
    )
  }
};

export const ViewBox = ({ parse, format, fieldType, ...rest }) => { return <Field parse={fieldType ? FieldValueParser(fieldType) : parse} format={fieldType ? FieldValueFormatter(fieldType) : format} {...rest} component={ViewBoxClass} /> } // eslint-disable-line
export default ViewBox
